import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { ChoosePinComponent } from './choose-pin/choose-pin.component';
import { ConfirmPinComponent } from './confirm-pin/confirm-pin.component';
import { EnterPinComponent } from './enter-pin/enter-pin.component';
import { PinMismatchComponent } from './pin-mismatch/pin-mismatch.component';
import { PinIncorrectComponent } from './pin-incorrect/pin-incorrect.component';
import { InfraModule } from '../infra/infra.module';
import { TicketRedemptionRoutingModule } from './ticket-redemption-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { PauseDispensePageComponent } from './pause-dispense-page/pause-dispense-page.component';

@NgModule({
    declarations: [
        HomeComponent,
        ChoosePinComponent,
        ConfirmPinComponent,
        EnterPinComponent,
        PinMismatchComponent,
        PinIncorrectComponent,
        PauseDispensePageComponent
    ],
    imports: [
        CommonModule,
        InfraModule,
        TicketRedemptionRoutingModule,
        MatGridListModule,
        MatButtonModule,
        HttpClientModule,
    ]
})
export class TicketRedemptionModule { }
